import { render, staticRenderFns } from "./ValidateSDAccountDataWithMasterDBView.vue?vue&type=template&id=270e3e31&scoped=true"
import script from "./ValidateSDAccountDataWithMasterDBView.vue?vue&type=script&lang=js"
export * from "./ValidateSDAccountDataWithMasterDBView.vue?vue&type=script&lang=js"
import style0 from "./ValidateSDAccountDataWithMasterDBView.vue?vue&type=style&index=0&id=270e3e31&prod&scoped=true&lang=css"
import style1 from "./ValidateSDAccountDataWithMasterDBView.vue?vue&type=style&index=1&id=270e3e31&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270e3e31",
  null
  
)

export default component.exports